import { Injectable } from "@angular/core";
import { HttpHeaders } from "@angular/common/http";
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from "@ptl/xhr";
import { ConnectureAgent, ConnectureAgentPermissionResponse, ConnectureAgentPermissionPayload } from "../../interfaces/connecture-sso.interface";


@Injectable({
    providedIn: 'root'
})
export class ConnectureEnrollService {

    constructor(
      private httpClient: HTTPWrapperContext
    ) { }

    /**
     @description Search for an existing connecture agent profile to determine if we need to create one
    */
    searchForConnectureAgent(userId: string): Promise<ConnectureAgent> {
        const requestConfig = new RequestConfigImplementation({
            method: REQUEST_METHODS.GET,
            url: `/connecture-agent/v3/ext/Agents/${userId}`,
            headers: new HttpHeaders({})
        });

        this.httpClient.disableErrorSnackbar(requestConfig);
        this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
        return this.httpClient.makeRequest(requestConfig);
    }

    /**
     @description 
        Create a connecture Agent profile.
        You should use the searchForConnectureAgent to ensure an agent does not exist before calling this service
    */
    createConnectureAgent(payload: ConnectureAgent): Promise<ConnectureAgent> {
        const requestConfig = new RequestConfigImplementation({
            method: REQUEST_METHODS.POST,
            url: '/connecture-agent/v3/ext/Agents',
            headers: new HttpHeaders({}),
            POST_OR_PUT_PAYLOAD: payload
        });

        this.httpClient.disableErrorSnackbar(requestConfig);
        this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
        return this.httpClient.makeRequest(requestConfig);
    }

    /**
     @description
        Search for an existing connecture permissions profile for a given agent profile.
    */
    searchForConnectureAgentPermissions(userId: string): Promise<ConnectureAgentPermissionResponse[]> {
        const requestConfig = new RequestConfigImplementation({
            method: REQUEST_METHODS.GET,
            url: `/connecture-agent/v3/ext/Agents/${userId}/sellingpermissions`,
            headers: new HttpHeaders({})
        });

        this.httpClient.disableErrorSnackbar(requestConfig);
        this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
        return this.httpClient.makeRequest(requestConfig);
    }

    /**
     @description 
        Create a connecture permissions profile.
        You should use the searchForConnectureAgentPermissions to ensure this agent's permission profile does not exist before calling this service
    */
    createConnectureAgentPermissionProfile(userId: string, payload: ConnectureAgentPermissionPayload[]): Promise<void> {
        const requestConfig = new RequestConfigImplementation({
            method: REQUEST_METHODS.POST,
            url: `/connecture-agent/v3/ext/Agents/${userId}/sellingpermissions`,
            headers: new HttpHeaders({}),
            POST_OR_PUT_PAYLOAD: payload
        });

        this.httpClient.disableErrorSnackbar(requestConfig);
        this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
        return this.httpClient.makeRequest(requestConfig);
    }

    /**
     @description 
        Remove a connecture permissions profile.
        There is no update permissions API so we have to remove existing permissions using the exact payload that was
        used to create them. Then we can re-create the profile with the updated payload
    */
    removeConnectureAgentPermissionProfile(userId: string, payload: ConnectureAgentPermissionPayload[]): Promise<void> {
        const requestConfig = new RequestConfigImplementation({
            method: REQUEST_METHODS.POST,
            url: `/connecture-agent/v3/ext/Agents/${userId}/sellingpermissions/remove`,
            headers: new HttpHeaders({}),
            POST_OR_PUT_PAYLOAD: payload
        });

        this.httpClient.disableErrorSnackbar(requestConfig);
        this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
        return this.httpClient.makeRequest(requestConfig);
    }
}